
import L from 'leaflet';
import TipoGeometria from '@/models/tipoGeometria';

export default {
	
	boundsToWKT (bounds) {
		return [
			'POLYGON((',
			bounds._southWest.lng, ' ', bounds._southWest.lat, ', ',
			bounds._southWest.lng, ' ', bounds._northEast.lat, ', ',
			bounds._northEast.lng, ' ', bounds._northEast.lat, ', ',
			bounds._northEast.lng, ' ', bounds._southWest.lat, ', ',
			bounds._southWest.lng, ' ', bounds._southWest.lat,
			'))'
		].join('');
	},

	layerToWKT (layer) {
		
		let lng = [];
		let lat = [];
		let coords = [];
		
		if (layer instanceof L.Polygon || layer instanceof L.Polyline) {
			
			let latlngs = layer.getLatLngs()[0];
			
			for (let i = 0; i < latlngs.length; i++) {
			
				latlngs[i];
			
				coords.push(latlngs[i].lng + ' ' + latlngs[i].lat);
			
				if (i === 0) {
					lng = latlngs[i].lng;
					lat = latlngs[i].lat;
				}
			};
			
			if (layer instanceof L.Polygon) {
			
				return 'POLYGON((' + coords.join(',') + ',' + lng + ' ' + lat + '))';
			
			} else if (layer instanceof L.Polyline) {
			
				return 'LINESTRING(' + coords.join(',') + ')';
			}

		} else if (layer instanceof L.Marker || layer instanceof L.CircleMarker) {

			return 'POINT(' + layer.getLatLng().lng + ' ' + layer.getLatLng().lat + ')';
		}
	},

	createGeoJsonLayer (geoJson, style) {
		
		var tipoGeometria = TipoGeometria.getFromGeoJson(geoJson);

		if (tipoGeometria.codigo !== TipoGeometria.PONTO.codigo) {

			return L.geoJSON(geoJson, { style: style });

		} else {

			return L.geoJSON(geoJson, {
				pointToLayer: function (feature, latlng) {
					return L.circleMarker(latlng, style);
				}
			});
		}
	},

	getLayerArea (layer) {

		if (layer.getLatLngs) {

			let layerLatlngs = layer.getLatLngs();
					
			if (!layerLatlngs || !layerLatlngs.length) return 0;

			let area = L.GeometryUtil.geodesicArea(layerLatlngs[0]);
			
			return area / 10000;

		} else {

			if (!layer.getLayers) return 0;
			
			let layers = layer.getLayers();

			if (!layers || !layers.length) return 0;

			let total = 0;

			for (let subLayer of layers) {

				total += this.getLayerArea(subLayer);
			}

			return total;
		}
	}
};



// WEBPACK FOOTER //
// ./src/utils/leafletUtils.js